import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { theme } from './theme';
import MainPage from './pages/MainPage';
import LoginPage from './pages/LoginPage/LoginPage';
import { ActivityHistoryPage } from './pages/ActivityHistory';
import { EmployeeManagement } from './components/EmployeeManagement';
import { AuthProvider } from './contexts/AuthContext';
import { AuthGuard } from './components/AuthGuard';
import {
  syncOnce,
  startWatching,
  stopWatching,
  forceRefresh,
} from './services/regulatoryRates/rateSyncService';
import { useRatesStore } from './store/ratesStore';

// 인증된 사용자를 위한 앱 컴포넌트
function AuthenticatedApp() {
  return (
    <AuthGuard>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/activity-history" element={<ActivityHistoryPage />} />
        <Route path="/employee-management" element={<EmployeeManagement />} />
        <Route path="/" element={<MainPage />} />
      </Routes>
    </AuthGuard>
  );
}

function App() {
  console.log('App component rendered');

  // 법령 요율 부트스트랩 — cache → Firestore 1회 동기화 + 실시간 구독.
  // 실패해도 default fallback 으로 동작하므로 앱 흐름은 영향 없음.
  useEffect(() => {
    syncOnce();
    startWatching();

    // 콘솔 진단 헬퍼: window.__rates() 로 현재 store 의 rates 객체 확인.
    // window.__refreshRates() 로 강제 새로고침. (개발 진단용)
    if (typeof window !== 'undefined') {
      (window as unknown as Record<string, unknown>).__rates = () =>
        useRatesStore.getState().current;
      (window as unknown as Record<string, unknown>).__refreshRates = forceRefresh;
    }

    return () => {
      stopWatching();
    };
  }, []);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthenticatedApp />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
